export enum ModalCloseReasons {
  RESTAURANT = 'restaurant',
  TIMEOUT = 'Timeout',
  BACKDROP = 'No Backdrop Close',
  NEXT_NAVIGATE = 'Next action is navigate'
}
